<script lang="ts" setup generic="T extends string">
import { motion } from 'motion-v';

interface Props {
	tabs: readonly T[];
	modelValue: T;
	layoutId?: string;
}

const props = withDefaults(defineProps<Props>(), {
	layoutId: 'tab-underline'
});

const emit = defineEmits<{
	'update:modelValue': [value: T];
}>();

function handleTabClick(tab: T) {
	emit('update:modelValue', tab);
}
</script>

<template>
	<!-- eslint-disable-next-line vue/component-name-in-template-casing -->
	<motion.div class="flex items-start gap-7" :initial="false">
		<div
			v-for="tab in tabs"
			:key="tab"
			class="flex flex-col items-center self-stretch"
		>
			<button
				type="button"
				:class="[
					tab === modelValue ? 'text-black' : 'text-[#4c4c4c]',
					'cursor-pointer'
				]"
				@click="handleTabClick(tab)"
			>
				<h3 class="text-[20px] tracking-[-0.4px]">{{ tab }}</h3>
			</button>
			<!-- eslint-disable-next-line vue/component-name-in-template-casing -->
			<motion.div
				v-if="tab === modelValue"
				data-testid="tab-underline"
				:layout-id="layoutId"
				:initial="false"
				:transition="{ type: 'spring', stiffness: 500, damping: 40 }"
				class="h-[2px] w-full bg-black"
			/>
		</div>
	</motion.div>
</template>
